<template>
	<v-app-bar app class="my-0" color="white" elevation="0" height="80">
		<v-container>
			<v-row>
				<v-col class="d-flex align-center">
					<router-link to="/" style="max-width: 100%">
						<v-img
							:src="require('@/assets/logo.png')"
							alt="Jobs Wish"
							class="shrink"
							contain
							height="50"
							max-width="300"
							width="100%"
						/>
					</router-link>
				</v-col>
			</v-row>
		</v-container>
	</v-app-bar>
</template>

<script>
export default {
	name: 'Header',
	data: () => ({
		//
	}),
};
</script>
